import { Component, h } from 'preact';

class TcrTitleBar extends Component
{
    constructor(props)
    {
        super(props);
    }

    render ()
    {
        let label = [];
        if (typeof this.props.title == 'string')
        {
            label = [this.props.title];
        }
        else if (typeof this.props.title != 'undefined')
        {
            label = this.props.title.filter(Boolean);
        }
        label = label.map((l, i) => {
            let encaps = <span>{l}</span>;
            let spacer = <span class="spacer">›</span>;
            if (i == 0)
            {
                return [encaps];
            }
            else
            {
                return [spacer, encaps];
            }
        });
        let actions = this.props.actions ? this.props.actions.map((action) =>
        {
            return (
                <div class="action" style={action.style} data-icon={action.icon} data-title={action.title} onClick={action.run}>{action.title}<div></div></div>
            );
        }) : undefined;

        //{this.props.noprint == 'true' ? ' noprint' : ''}
        return (
            <div class="tcr-title-bar">
                <h1>{label}</h1>
                <div class="title-actions">
                    {actions}
                </div>
            </div>
        );
    }

}

export { TcrTitleBar };
